<script setup lang="ts">
const props = defineProps<{
  icon: string | [string, string]
  type?: string
  size?: string | number
  msize?: string | number
}>()

const iconClass = (() => {
  if (props.type)
    return `${props.type} fa-${props.icon}`
  const iconArray = typeof props.icon === 'string' ? props.icon.split(/-(.+)/) : props.icon
  return `${iconArray?.[0]} fa-${iconArray?.[1]}`
})()

const sizes = {
  desktop: `${props.size}px`,
  desktopFont: props.size ? `${Number(props.size) >= 40 ? +props.size * 0.8 : props.size}px` : 'inherit',
  mobile: `${props.msize || props.size}px`,
  mobileFont: props.msize ? `${Number(props.msize) >= 40 ? +props.msize * 0.8 : props.msize}px` : props.size ? `${Number(props.size) > 39 ? +props.size * 0.8 : props.size}px` : 'inherit',
}
</script>

<template>
  <div class="flex items-center justify-center icon">
    <ClientOnly>
      <i :class="[iconClass]" />
    </ClientOnly>
  </div>
</template>

<style scoped>
.icon {
  width: v-bind("sizes.mobile");
  height: v-bind("sizes.mobile");
  font-size: v-bind("sizes.mobileFont");
  @screen md {
    width: v-bind("sizes.desktop");
    height: v-bind("sizes.desktop");
    font-size: v-bind("sizes.desktopFont");
  }
}
</style>
